import { render, staticRenderFns } from "./cocktail-tall-8.vue?vue&type=template&id=549fe33f"
import script from "./cocktail-tall-8.vue?vue&type=script&lang=js"
export * from "./cocktail-tall-8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports